'use client'

import { useQueryResults } from "@/hooks/useQueryResults"
import { useMemo, useState } from "react"
import { DatasetAreaChart } from "./charts/dataset-area-chart"
import { Percent, Sigma } from "lucide-react"

export function SffBalancesChart() {
    const { results } = useQueryResults({id: 6808860})

    const [showPct, setShowPct] = useState(false)
    const percentFormatter = new Intl.NumberFormat("en", {style: 'percent', maximumFractionDigits: 2})
    const formatter = new Intl.NumberFormat("en", {maximumFractionDigits: 0})
    const axisFormatter = new Intl.NumberFormat('en', {notation: 'compact', currency: "USD", currencyDisplay: 'narrowSymbol', style: 'currency'})
    
    const dataset = useMemo(() => {
        if (!results) return {dimensions: [], source: []}
        
        // Extract unique symbols from the nested data structure
        const symbols = [
            ...new Set(
                Object.keys(results[0] || {}).filter(k => k !== 'date_unix' && k !== 'day' && k !== 'date').filter(Boolean)
            )
        ].sort()

        const res = results.sort((a, b) => b.date.valueOf() - a.date.valueOf())

        // Get unique dates
        const days = [...new Set(results.map(r => r.date.valueOf()))].sort()
        
        return {
            dimensions: ['date', ...symbols],
            source: res.map(r => [r.date.toDate(), ...symbols.map(s => r[s])])
        }
    }, [results])

    const yAxisMax = useMemo(() => {
        return Math.max(...(dataset.source as unknown as number[][]).map(ds => ds.slice(1).filter(x => x > 0).reduce((a, i) => i + a, 0)))
    }, [dataset])

    return <div className="w-full h-[40vh]">
        <DatasetAreaChart
            dataset={dataset}
            title="SFF Token Balances"
            description="Token balances over time"
            stack
            showTotal
            yAxisFormatter={(n) => axisFormatter.format(n)}
            tooltip={{
                seriesValueFormatter: (value) => `${formatter.format(value)}`
            }}
            yAxisMax={yAxisMax}
        />
    </div>
}
